import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../components/AppLayout';
import { ParkingCircle } from 'lucide-react';

const ReportsParking: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToWorkspaces = () => {
    navigate('/workspaces');
  };

  return (
    <AppLayout onBack={handleBackToWorkspaces}>
      <div className="page-container">
        <div className="page-header">
          <div>
            <h1 style={{ margin: 0 }}>Parking Reports</h1>
            <p style={{ fontSize: '14px', color: '#6B7280', margin: '8px 0 0 0' }}>
              Parking reports and analytics
            </p>
          </div>
        </div>

        <div className="page-content" style={{ marginTop: '24px' }}>
          <div style={{
            background: 'white',
            borderRadius: '12px',
            padding: '24px',
            boxShadow: '0 4px 12px rgba(72, 24, 47, 0.15), 0 2px 4px rgba(72, 24, 47, 0.08)'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '60px 20px',
              color: '#6B7280'
            }}>
              <ParkingCircle size={48} color="#A89088" style={{ marginBottom: '16px' }} />
              <p style={{ fontSize: '16px', margin: 0 }}>Parking Reports - Coming Soon</p>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default ReportsParking;
